import React,{PureComponent} from "react";
import autoBind from "react-autobind";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import { Button, Jumbotron, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";

import WebPlayerInternal from "./WebPlayerInternal";
import state from "../../state";
import * as playerActions from "../../actions/playerActions";
import { getQueryStringParam } from "../../utils/utils";
import { getUrlForValue } from "../../actions/drive";

// import { isMobile, isAndroid } from "react-device-detect";

class WebPlayer extends PureComponent {

	constructor(props) {
		super(props);
		const skipNarration = getQueryStringParam("skipNarration");
		const lang = getQueryStringParam("lang");

		let titleCard;

		console.log("Web Player: constructor", props);

		let activities = [];
		if (global.hasOwnProperty("activities") && global.activities.length > 0) {
			console.log("Web Player: Global activities available");
			activities = global.activities;
		} else if (props.activities && props.activities.length > 0) {
			const activity = props.activities[0];
			console.log("Web Player: Falling back to props", activity, props.activityId);
			if (activity.id !== props.activityId && props.hasOwnProperty("activityId")) {
				props.activities.forEach(act => {
					if (act.id === props.activityId) {
						activities.push(act);
					}
				});
			} else {
				activities = [activity];
			}
		}
		
		if (activities.length > 0) {
			console.log("Web Player: Got activity info", activities);
			const activity = activities[0];
			titleCard = {};
	
			titleCard.title = activity.name;
			titleCard.subtitle = null;
			titleCard.titleBackgroundColor = "white";
			titleCard.titleColor = "black";

			if (activity.backgroundAudio && activity.backgroundAudio !== "") {
				console.log("Web Player: Get background audio");
				titleCard.backgroundAudio = getUrlForValue(activity.backgroundAudio, activity, this.props.drive, this.props.env);
				console.log("Web Player: Got background audio URL", titleCard.backgroundAudio);
			}
	
			if (activity.hasOwnProperty("authorProperties")) {
				if (activity.authorProperties.hasOwnProperty("titleCard")) {
					titleCard = Object.assign(titleCard, activity.authorProperties.titleCard);
				}

				if (activity.authorProperties.hasOwnProperty("iosBackgroundAudio")) {
					titleCard.iosBackgroundAudio = activity.authorProperties.iosBackgroundAudio;
				}
				//https://assets-ambifi-com.s3.amazonaws.com/public/projects/hhph/bg.mp3
			}
		}

		this.state = {
			confirmedVoice: false,
			skipNarration: !!skipNarration,
			lang,
			titleCard
		};

		autoBind(this);
		// console.log("WEB PLAYER CONSTRUCTOR");
	}
	async handleChooseVoice(activateVoice, backgroundAudio = null, iosBackgroundAudio=null) {
		if (activateVoice) {
			await playerActions.setAudioOn(undefined, backgroundAudio, iosBackgroundAudio, true);
		} else {
			await playerActions.setAudioOff();
		}
		this.setState({
			confirmedVoice: true,
			activateVoice
		});
	}

	render() {
		let player = null;
		const { confirmedVoice, activateVoice, skipNarration, titleCard } = this.state;
		const { initSpinner } = this.props;

		let backgroundAudio = null;
		let iosBackgroundAudio = null;
		if (titleCard && titleCard.backgroundAudio) {
			backgroundAudio = titleCard.backgroundAudio;
		}
		if (titleCard && titleCard.iosBackgroundAudio) {
			iosBackgroundAudio = titleCard.iosBackgroundAudio;
		}
		if (!confirmedVoice && !this.props.disableVoice && !skipNarration) {
			player = <div className="container" style={{ backgroundColor: "#666666", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
				<Row>
					<Col xs={12}>
						<Jumbotron>
							{/* {isMobile && 
								<div style={{backgroundColor:"white", padding: "15px", borderRadius: "10px"}}>
									<h3>Mobile Experience</h3>
									<p>AmbiFi provides even a better experience through our mobile app. If you don't have the app, you can download it now.</p>
									{isAndroid && 
											<Button bsSize="large" bsStyle="primary" onClick={() => {
												window.location.href = "https://play.google.com/store/apps/details?id=com.ambifimobile&hl=en_US";
											}}> Go to Google Play</Button>
									}
									{!isAndroid && 
											<Button bsSize="large" bsStyle="primary" onClick={() => {
												window.location.href = "itms-apps://apps.apple.com/us/app/ambifi/id1375015365";
											}}> Go to App Store</Button>
									}
									<div style={{marginTop: "15px"}}>
										<p>If you already have it...</p>
										{isAndroid && 
												<Button bsSize="large" bsStyle="primary" onClick={() => {
												}}> Go to AmbiFi</Button>
										}
										{!isAndroid && 
												<Button bsSize="large" bsStyle="primary" onClick={() => {

												}}> Go to AmbiFi</Button>
										}
									</div>
								</div>
							} */}
							{(this.state.hasOwnProperty("titleCard") && this.state.titleCard) &&
								<div>
									<div style={{backgroundColor:this.state.titleCard.titleBackgroundColor?this.state.titleCard.titleBackgroundColor:"white", color: this.state.titleCard.titleColor?this.state.titleCard.titleColor:"black", padding: "15px", borderRadius: "10px"}}>
										<h1 style={{textAlign: "center"}}>{this.state.titleCard.title}</h1>
										{this.state.titleCard.subtitle && <h3 style={{textAlign: "center"}}>{this.state.titleCard.subtitle}</h3>}
									</div>
									<div style={{textAlign: "center", padding: "5px"}}>Powered by <a href="https://www.ambifi.com" target="_blank" rel="noopener noreferrer"><img style={{width: "40px"}} alt="AmbiFi Logo" src="https://app.ambifi.com/assets/ambifi-logo.png"/></a></div>
								</div>
							}
							{/* <h3>{this.state.lang === "es" ? "Narración" : "Run"}</h3> */}
							{(!this.state.lang || this.state.lang === "en") && <p>Please select one of the two audio options below, you can always change this later on.</p>}
							{this.state.lang === "es" && <p>Elija si desea o no la narración de voz. Siempre puedes desactivarlo / activarlo más tarde.</p>}
							{this.state.lang === "pt" && <p>Por favor, selecione uma das duas opções de áudio abaixo. Você sempre pode alterar isso mais tarde.</p>}
							{(!this.state.lang || this.state.lang === "en") && <p style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
								<Button bsSize="large" bsStyle="danger" onClick={() => this.handleChooseVoice(false)}><FontAwesomeIcon icon="ban" /> Audio Off</Button>
								<Button style={{ marginLeft: "5px" }} bsSize="large" bsStyle="success" onClick={() => this.handleChooseVoice(true, backgroundAudio, iosBackgroundAudio)}><FontAwesomeIcon icon={["fas", "volume-up"]} /> Audio On</Button>
							</p>}
							{this.state.lang === "es" && <p style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
								<Button bsSize="large" bsStyle="danger" onClick={() => this.handleChooseVoice(false)}><FontAwesomeIcon icon="ban" /> Audio apagado</Button>
								<Button style={{ marginLeft: "5px" }} bsSize="large" bsStyle="success" onClick={() => this.handleChooseVoice(true, backgroundAudio, iosBackgroundAudio)}><FontAwesomeIcon icon={["fas", "volume-up"]} /> Audio encendido</Button>
							</p>}
							{this.state.lang === "pt" && <p style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
								<Button bsSize="large" bsStyle="danger" onClick={() => this.handleChooseVoice(false)}><FontAwesomeIcon icon="ban" /> Áudio desligado</Button>
								<Button style={{ marginLeft: "5px" }} bsSize="large" bsStyle="success" onClick={() => this.handleChooseVoice(true, backgroundAudio, iosBackgroundAudio)}><FontAwesomeIcon icon={["fas", "volume-up"]} /> Áudio ativado</Button>
							</p>}
						</Jumbotron>
					</Col>
				</Row>
				{initSpinner && <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, right: 0, display: "flex", justifyContent: "center", alignItems: "center",color:"white",fontSize:"4em", backgroundColor:"rgba(0,0,0,.5)" }}><FontAwesomeIcon icon="spinner" spin/></div>}
			</div>;
		} else {
			player = <WebPlayerInternal activateVoice={activateVoice} {...this.props} />;
		}
		return player;
	}

	setStateValue(path, value) {
		state.set(path, value);
	}

	getStateValue(path) {
		return state.get(path);
	}

	async saveActivity() {
		return playerActions.saveActivity();
	}

	componentWillUnmount() {
		playerActions.stopBackgroundAudio();
		playerActions.cancelVoice();
	}
}

WebPlayer.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	initSpinner: ["appPreferences", "voice", "initSpinner"]
}, WebPlayer);